import jwt_decode from 'jwt-decode';
import { AppDispatch } from 'src/store/rootStore';
import { setAccessToken } from 'src/store/session/sessionSlice';
import { SessionState } from 'src/store/session/sessionState.model';
import { sendTokenExpired } from '../event-message/event-message.service';
import axiosRetry from 'axios-retry';
import axios, { AxiosError } from 'axios';
import i18n from 'i18next';
import { ErrorCode } from 'src/enums/error-code.enum';
const { t } = i18n;

class RefreshTokenService {
    private readonly appId = 'exocad-3d-viewer';
    private readonly multiplierToMillisecond = 1000;
    private readonly unauthorizedErrorStatus = 401;
    private accessToken: string;
    private sessionId: string;
    private refreshTokenUrl: string;
    private dispatch: AppDispatch;

    init(dispatch: AppDispatch, session: SessionState) {
        this.dispatch = dispatch;
        this.updateData(session);
    }

    public async checkAndUpdateToken(force = false) {
        try {
            if (this.isTokenExpired() || force) {
                const pathUrl = `?sessionId=${this.sessionId}&appId=${this.appId}`;
                const urlWithParam = this.refreshTokenUrl.split('?')[0] + pathUrl;
                axiosRetry(axios, { retries: 3,
                    retryCondition: (error) => error.response.status !== this.unauthorizedErrorStatus});
                const response = await axios.get<RefreshTokenResponse>(urlWithParam, {
                    headers: {
                        Authorization: `Bearer ${this.accessToken}`,
                    },
                });
                this.dispatch(setAccessToken(response.data.accessToken));
            }
        } catch (exception) {
            console.log(exception);
            sendTokenExpired(this.sessionId);
            const error = new AxiosError(ErrorCode.UpdateToken);
            console.log(error.message);
            return Promise.reject(error);
        }
    }

    private isTokenExpired() {
        const decode = jwt_decode(this.accessToken);
        let timeout =
            decode.exp * this.multiplierToMillisecond - new Date().getTime();
        return timeout <= 0;
    }

    private updateData(session: SessionState) {
        this.accessToken = session.accessToken;
        this.sessionId = session.externalSessionId;
        this.refreshTokenUrl = session.refreshTokenUrl;
    }
}

export interface RefreshTokenResponse {
    accessToken: string;
    session: string;
}

export default new RefreshTokenService();
